import { Component, Input, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { Option } from './models/option';

@Component({
  selector: 'vrc-option',
  templateUrl: './vrc-option.component.html',
  styleUrls: ['./vrc-option.component.scss']
})
export class VrcOptionComponent implements Option, AfterViewInit {
  @Input() value!: any;
  @Input() isCurrent = false;
  content!: any;
  constructor(private element: ElementRef) { }
  ngAfterViewInit(): void {
    this.content = this.element?.nativeElement?.innerHTML;
  }
}
